import React, { useState,useRef,useContext,useEffect } from 'react';
import { QRCodeComponent } from '../../components/QRCodeComponent';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { ShoppingStart } from '../../components/ShoppingStart';
import { iAeonSetData } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Checkout.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiMeisai(props) {

// const [se08_se] = useSound(se_08);

// const ShoppingStartContext = useContext(ShoppingStart);

useEffect(() => {
	document.body.classList.add('bg_white');
	document.getElementById('header').classList.add('is_fixed');
	document.documentElement.classList.add('is_fixed');
	document.body.classList.add('is_fixed');

	// document.getElementById('header').classList.remove('is_fixed');
	// document.getElementById('header').classList.remove('is_behind');

	console.log("props.saleData:");
	console.log(props.saleData);

	// props.setRegiType("regi_senyou_comp");

	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		console.log("iAEON 有効");
	}else{ //iAEON無効
	}

	//高さ設定
	if(props.appHeight !== ""){
		console.log("props.appHeight: " + props.appHeight);
		let element2 = document.getElementById('regiFrame');
		if(element2){
			element2.style.height = props.appHeight + 'px';
		}
	}else {
		if(window.innerWidth >= 320){
			document.documentElement.style.zoom = window.innerWidth / 390;
		}else{
			document.documentElement.style.zoom = 1;
		}
		setTimeout(function(){
			// document.documentElement.style.zoom = window.innerWidth / 390;
			if(window.innerWidth >= 320){
				document.documentElement.style.zoom = window.innerWidth / 390;
			}else{
				document.documentElement.style.zoom = 1;
			}

			let sHeight = window.innerHeight;
			// var wzoom = window.innerWidth / 390;
			if(window.innerWidth >= 320){
				var wzoom = window.innerWidth / 390;
			}else{
				var wzoom = 1;
			}
			let zHeight = sHeight * wzoom;
			let nHeight = sHeight - (zHeight - sHeight);
			console.log("sHeight: "+sHeight);
			console.log("wzoom: "+wzoom);
			console.log("zHeight: "+zHeight);
			console.log("nHeight: "+nHeight);
			let element = document.getElementById('regiFrame');
			if (element) {
				element.style.height = nHeight + 'px';
			}
		}, 300);
		setTimeout(function(){
			// document.documentElement.style.zoom = window.innerWidth / 390;
			if(window.innerWidth >= 320){
				document.documentElement.style.zoom = window.innerWidth / 390;
			}else{
				document.documentElement.style.zoom = 1;
			}
		}, 600);
	}

}, []);


const closeApp = () => {
	props.setErrFlg(true);
	props.setErr([true,`shopping_cancel03`,`;;;;;`]);
	// se08_se();
	props.setSoundState("se08_se");
}


// const sharedInfo = useContext(SharedInfoContext);


//明細一覧：通常
const MeisaiListNormal = (props) => {
	console.log("props.item.count: " + props.item.count);
	const elements = [];
	for (var i = 0; i < props.item.count; i++) {
	elements.push(
		<div key={props.index} data-barcode={props.item.barCode} className={`${styles.meisaiList_box}`}>
			<div className={styles.meisaiList_in}>
				<p className={styles.meisaiList_name}>{props.item.receiptKanji}</p>
				<div className={styles.meisaiList_priceBox}>
					<p className={styles.meisaiList_price}>
						<span className={`${styles.meisaiList_price_default} ${props.item.discountSellPrice ? styles.cancel : ''}`}><small>¥</small>
						{(props.item.sellPrice).toLocaleString('ja-JP')}
						</span>
					</p>
				</div>
			</div>
			{
				(() => {
					if (props.item.discountType === 1) {
						return(
							<div className={styles.meisaiList_discount}>
								<p className={styles.meisaiList_discount_txt}>レジにて<strong>{(props.item.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
								<p className={styles.meisaiList_discount_price}><small>¥</small>{(props.item.discountSellPrice).toLocaleString('ja-JP')}</p>
							</div>
						)
					}else if (props.item.discountType === 2) {
						return(
							<div className={styles.meisaiList_discount}>
								<p className={styles.meisaiList_discount_txt}>レジにて<strong>{props.item.discountAmount}</strong>%OFF</p>
								<p className={styles.meisaiList_discount_price}><small>¥</small>{(props.item.discountSellPrice).toLocaleString('ja-JP')}</p>
							</div>
						)
					}else if (props.item.discountType === 3) {
						return(
							<div className={styles.meisaiList_discount}>
								<p className={styles.meisaiList_discount_txt}>レジにて</p>
								<p className={styles.meisaiList_discount_price}><small>¥</small>{(props.item.discountSellPrice).toLocaleString('ja-JP')}</p>
							</div>
						)
					}
				})()
			}
		</div>
	)
	}
	return elements;
}


return (
<>
<div id="regiFrame" className={`${styles.regiFrame} ${styles.regiFrame_meisai}`}>
<div id="meisai" className={styles.meisaiBox}>

	<p className={styles.meisaiBox_tit}>お支払い金額はレジにて<br/>ご確認ください</p>
	<div className={styles.meisaiBox_list}>
	<div className={styles.meisaiBox_list_in}>

		<div className={styles.meisaiList}>

{
	(() => {
		return (
			<>

		{props.saleData.data.saleList.map((item, index) => {
			// <li key={index}>{item}</li>
			if(item.itemList !== null){ //バンドル商品
				return (
					<div key={index} data-barcode={item.itemList[0].barCode} className={`${styles.meisaiList_box} ${styles.is_bundle}`}>
						{item.itemList.map((sitem, sindex) => (
							<>
							<div className={styles.meisaiList_in}>
								<p className={styles.meisaiList_name}>{sitem.receiptKanji}</p>
								<div className={styles.meisaiList_priceBox}>
									<p className={styles.meisaiList_price}>
										<span className={`${styles.meisaiList_price_default} ${item.bundlesetprice ? styles.cancel : ''}`}><small>¥</small>
										{(sitem.sellPrice).toLocaleString('ja-JP')}
										</span>
									</p>
								</div>
							</div>
							</>
						))}
						<div className={styles.meisaiList_discount}>
							<p className={styles.meisaiList_discount_txt}>まとめ値引<strong>{(item.summaryDiscount).toLocaleString('ja-JP')}</strong>円OFF</p>
							<p className={styles.meisaiList_discount_price}><small>¥</small>{(item.bundlesetprice).toLocaleString('ja-JP')}</p>
						</div>
					</div>
				)
			}else{ //通常商品
				return (
					<MeisaiListNormal item={item} index={index} />
				// <div key={index} data-barcode={item.barCode} className={`${styles.meisaiList_box}`}>
				// 	<div className={styles.meisaiList_in}>
				// 		<p className={styles.meisaiList_name}>{item.receiptKanji}</p>
				// 		<div className={styles.meisaiList_priceBox}>
				// 			<p className={styles.meisaiList_price}>
				// 				<span className={`${styles.meisaiList_price_default} ${item.discountSellPrice ? styles.cancel : ''}`}><small>¥</small>
				// 				{(item.sellPrice).toLocaleString('ja-JP')}
				// 				</span>
				// 			</p>
				// 		</div>
				// 	</div>
				// 	{
				// 		(() => {
				// 			if (item.discountType === 1) {
				// 				return(
				// 					<div className={styles.meisaiList_discount}>
				// 						<p className={styles.meisaiList_discount_txt}>レジにて<strong>{(item.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
				// 						<p className={styles.meisaiList_discount_price}><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
				// 					</div>
				// 				)
				// 			}else if (item.discountType === 2) {
				// 				return(
				// 					<div className={styles.meisaiList_discount}>
				// 						<p className={styles.meisaiList_discount_txt}>レジにて<strong>{item.discountAmount}</strong>%OFF</p>
				// 						<p className={styles.meisaiList_discount_price}><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
				// 					</div>
				// 				)
				// 			}else if (item.discountType === 3) {
				// 				return(
				// 					<div className={styles.meisaiList_discount}>
				// 						<p className={styles.meisaiList_discount_txt}>レジにて</p>
				// 						<p className={styles.meisaiList_discount_price}><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
				// 					</div>
				// 				)
				// 			}
				// 		})()
				// 	}
				// </div>
				)
			}
		})
		}

		</>
	)
	})()
}


			{/* <div className={styles.meisaiList_box}>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>コカ・コーラ 綾鷹</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={styles.meisaiList_price_default}><small>¥</small>78</span>
						</p>
					</div>
				</div>
			</div>

			<div className={styles.meisaiList_box}>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>コカ・コーラ 綾鷹</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={styles.meisaiList_price_default}><small>¥</small>78</span>
						</p>
					</div>
				</div>
			</div>

			<div className={`${styles.meisaiList_box} ${styles.is_bundle}`}>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>トップバリュ 糖質をおさえたブランデニッシュ 2個入</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={`${styles.meisaiList_price_default} ${styles.cancel}`}><small>¥</small>198</span>
						</p>
					</div>
				</div>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>トップバリュ 糖質をおさえたブランデニッシュ 2個入</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={`${styles.meisaiList_price_default} ${styles.cancel}`}><small>¥</small>198</span>
						</p>
					</div>
				</div>
				<div className={styles.meisaiList_discount}>
					<p className={styles.meisaiList_discount_txt}>まとめ値引<strong>258</strong>円OFF</p>
					<p className={styles.meisaiList_discount_price}><small>¥</small>138</p>
				</div>
			</div>

			<div className={styles.meisaiList_box}>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>ダミーテキストダミーテキストダミーテキストダミーテキストダミーテキストダミーテキスト</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={`${styles.meisaiList_price_default} ${styles.cancel}`}><small>¥</small>198</span>
						</p>
					</div>
				</div>
				<div className={styles.meisaiList_discount}>
					<p className={styles.meisaiList_discount_txt}>レジにて<strong>30</strong>%OFF</p>
					<p className={styles.meisaiList_discount_price}><small>¥</small>138</p>
				</div>
			</div>

			<div className={styles.meisaiList_box}>
				<div className={styles.meisaiList_in}>
					<p className={styles.meisaiList_name}>レタス 1玉</p>
					<div className={styles.meisaiList_priceBox}>
						<p className={styles.meisaiList_price}>
							<span className={`${styles.meisaiList_price_default} ${styles.cancel}`}><small>¥</small>248</span>
						</p>
					</div>
				</div>
			</div> */}

		</div>
		<div className={styles.meisaiList_spacer}></div>

	</div>
	</div>

	<div className={styles.meisaiBox_btnBox}>
		<div className={`${styles.regiBox_info} ${styles.regiBox_info_meisai}`}>
			<p className={styles.regiBox_info_label}>点数</p>
			<p className={styles.regiBox_info_num}>{props.saleData.data.sumItemCount}</p>
			<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
		</div>
		<button className={`commonBtn commonBtn01 ${styles.meisaiCloseBtn}`} onClick={closeApp}><span>お買物を終了する</span></button>
	</div>

</div>
</div>
</>
)

}
